import * as THREE from 'three'

import shaderFragment from '../../shaders/ground/fragment.glsl'
import shaderVertex from '../../shaders/ground/vertex.glsl'

export default function()
{
    return new THREE.ShaderMaterial({
        uniforms: {
            uTopLeft: { value: new THREE.Color('#21172e') },
            uTopRight: { value: new THREE.Color('#2d2039') },
            uBottomRight: { value: new THREE.Color('#15121e') },
            uBottomLeft: { value: new THREE.Color('#1d1829') }
        },
        vertexShader: shaderVertex,
        fragmentShader: shaderFragment
    })
}
